import SumoLogger, { SumoLoggerOptions } from 'sumo-logger';
//import util from 'util';
const reactUrl: string = process.env.REACT_APP_BASE_REACT_URL;

const opts: SumoLoggerOptions = {
  endpoint:
    'https://endpoint4.collection.sumologic.com/receiver/v1/http/ZaVnC4dhaV0W_xdFB8Or-OoDoMhNZKVEEI9SHRCE1odK0Ray2C-yukS5q54R8Jdz0uhOpWc94PRmaF6b93JXZMYZ2XzbPtL5qDofLjgXAyo-lqjsHuBLjw==',
  sourceCategory: 'SfaWebsite',
  clientUrl: reactUrl,
  interval: 10000, // Send messages in batches every 10 seconds
  batchSize: 100000, // Or when total log length reaches 100k characters
  sendErrors: true,
};

export enum LogLevel {
  DEBUG,
  INFO,
  WARN,
  ERROR,
}

export class Logger {
  private static _level: LogLevel = LogLevel.INFO;

  private static _sumoLogger: SumoLogger = null;

  public static init(level: LogLevel): void {
    // Instantiate the SumoLogger
    console.log('logger initialized');
    Logger._level = level;
    Logger._sumoLogger = new SumoLogger(opts);
  }

  private static stringify(obj: any): string {
    return JSON.stringify(
      obj,
      function (key, val) {
        if (typeof val === 'function') {
          return val + ''; // implicitly `toString` it
        }
        if (val instanceof Element) {
          return val + '';
        }
        return val;
      },
      2
    );
  }

  private static stringifyObject(obj: any): string {
    let msgString = '';
    if (obj && obj.stack && obj.message && obj.name) {
      // it's an error object, probably
      msgString += Logger.stringify({ name: obj.name, message: obj.message, stack: obj.stack });
    } else if (typeof obj === 'string' || obj instanceof String) {
      msgString += obj;
    } else {
      msgString += Logger.stringify(obj);
    }
    return msgString;
  }

  private static parseLogMessage(msgString: string, msg: any, ...optionalParams: any[]): string {
    msgString += Logger.stringifyObject(msg);

    if (optionalParams && optionalParams.length > 0) {
      let params = optionalParams[0];
      for (let i = 0; i < params.length; i++) {
        msgString += Logger.stringifyObject(params[i]);
      }
    }
    return msgString;
  }

  public static error(msg: any, ...optionalParams: any[]) {
    try {
      console.error(msg, optionalParams);
      if (Logger._sumoLogger === null) return;
      let msgString: string = '';
      msgString = Logger.parseLogMessage(msgString, msg, optionalParams);
      Logger._sumoLogger.log({ msg: msgString, level: 'Error' });
    } catch (e) {
      console.error('Logger.error ', e);
    }
  }

  public static info(msg: any, ...optionalParams: any[]) {
    try {
      console.log(msg, optionalParams);
      if (Logger._sumoLogger === null) return;
      let msgString: string = '';
      msgString = Logger.parseLogMessage(msgString, msg, optionalParams);
      Logger._sumoLogger.log({ msg: msgString, level: 'Information' });
    } catch (e) {
      console.error('Logger.info ', e);
    }
  }

  public static warn(msg: any, ...optionalParams: any[]) {
    try {
      console.warn(msg, optionalParams);
      if (Logger._sumoLogger === null) return;
      let msgString: string = '';
      msgString = Logger.parseLogMessage(msgString, msg, optionalParams);
      Logger._sumoLogger.log({ msg: msgString, level: 'Warning' });
    } catch (e) {
      console.error('Logger.warn ', e);
    }
  }
}
